import { AbstractGridStrategy } from './abstract.strategy';

export class ItemsGridStrategy extends AbstractGridStrategy {
    constructor(items: number) {
        super();
        this.itemsOnPage = items;
    }

    public getGridHeight(): number {
        let height = this.headerHeight ? this.headerHeight : 0;
        height += this.itemsOnPage * this.a9GridConstants.dataRowHeight;
        return height;
    }

    public getGridPageAmount(): number {
        return this.itemsOnPage;
    }

    public showPagination() {
        return true;
    }

    public detach() {}
    public setGridElement(gridElement: HTMLElement): void {}
}
